export enum LocalStorageNames {
    CustomerAddresses = 'customerAddresses',
    PrevUrl = 'prevUrl',
    LastUsedAddress = 'lastUsedAddress',
    LoggingSocial = 'loggingSocial'
}